// Max image size in pixels
export const MAX_IMAGE_SIZE = 300;